import React from "react";
import { Button } from "react-bootstrap";

const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal d-block" : "modal d-none";

  return (
    <div className={showHideClassName}>
      <div className="modal-container">
        {children}
        <Button variant="link" href="#" className="loginButton" onClick={handleClose}>
          close
        </Button>
      </div>
    </div>
  );
};

export default Modal;